import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalWifiOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_wifi_off"}/>
}
